import { useQuery } from "react-query"
import { checkClientVersion } from "./versionCheckApi"

const queryKey = ['check-client-version']

const HOUR_IN_MILLISECONDS = 60 * 60 * 1000

export const useClientVersionCheck = () => {
  return useQuery(queryKey, {
    queryFn: () => checkClientVersion(),
    staleTime: 11 * HOUR_IN_MILLISECONDS,
    refetchInterval: 12 * HOUR_IN_MILLISECONDS
  })
}
